export default "__VITE_ASSET__DbsNk9hv__"